<template>
    <div class="row clearfix">
        <div v-if="loading" class="loading"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="">
                <div class="header">
                    <h2>История заказов</h2>
                </div>
                <div class="body table-responsive">
                    <table class="table table-bordered table-striped js-table dataTable order-table">
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>Номер заказа</th>
                            <th>Имя компании</th>
                            <th>Время заказа</th>
                            <th>Общая сумма</th>
                            <th>Опции</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item) in items">
                            <td>{{ item.id }}</td>
                            <td>{{ item.order_number}}</td>
                            <td>{{ item.company }}</td>
                            <td>{{ item.created_at }}</td>
                            <td>{{ item.total_price }} тг</td>
                            <td>
                                <router-link class="btn btn-primary" :to="'/admin/histories/edit/' + item.order_number">Изменить</router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AdminHistory",

        props: [
          'user_id'
        ],

        data() {
            return {
                items: [],
                loading: false,
            }
        },

        mounted() {
            this.loading = true

            this.axios
                    .put(this.axios.defaults.baseURL + 'admin/histories_json', {
                        "categories":{"StrucrtureCategories":{"v1c_id":"<ORDER_KZ210419-113339>","name":"Да"}}
                    })
                    .then(response => {
                        console.log(response)
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                })

            if(typeof this.user_id !== 'undefined') {
                this.axios
                .get(this.axios.defaults.baseURL + 'admin/histories?user=' + this.user_id)
                .then(response => {
                    this.items = response.data.histories;
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false
                })
            } else {
                this.axios
                    .get(this.axios.defaults.baseURL + 'admin/histories')
                    .then(response => {
                        this.items = response.data.histories;
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                        this.loading = false
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/admin/histories/Index.vue